/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid } from "frontend/src/components/Layout"
import ScriptTag from "react-script-tag"
import "./HtmlWidget.css"

function HtmlWidget({ containerID, scriptUrl }) {
  const { narrow: Narrow } = SectionGrid
  return (
    <SectionGrid>
      <Narrow>
        <div id={containerID}></div>
        <ScriptTag type="text/javascript" defer={true} src={scriptUrl} />
      </Narrow>
    </SectionGrid>
  )
}

export { HtmlWidget }
